// Basemap style specs. ESRI World Imagery is free for non-commercial and
// light commercial use with attribution — same basemap Vetro uses. We also
// offer a streets-focused style for clarity while editing.
const GLYPHS = 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf';
const ESRI_ATTRIB = 'Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics';
export const SATELLITE_STYLE = {
    version: 8,
    glyphs: GLYPHS,
    sources: {
        'esri-imagery': {
            type: 'raster',
            tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
            tileSize: 256,
            attribution: ESRI_ATTRIB,
            maxzoom: 19,
        },
        // City / town / neighborhood labels + state and county boundaries.
        // Cruft-free on imagery — white text with dark halo, stands out on aerial.
        'esri-places': {
            type: 'raster',
            tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}'],
            tileSize: 256,
            attribution: ESRI_ATTRIB,
            maxzoom: 19,
        },
        // Road names / highway shields.
        'esri-transportation': {
            type: 'raster',
            tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}'],
            tileSize: 256,
            attribution: ESRI_ATTRIB,
            maxzoom: 19,
        },
    },
    layers: [
        { id: 'bg', type: 'background', paint: { 'background-color': '#0b1220' } },
        { id: 'imagery', type: 'raster', source: 'esri-imagery' },
        { id: 'transportation', type: 'raster', source: 'esri-transportation', paint: { 'raster-opacity': 0.9 } },
        { id: 'places', type: 'raster', source: 'esri-places', paint: { 'raster-opacity': 0.95 } },
    ],
};
export const STREETS_STYLE = {
    version: 8,
    glyphs: GLYPHS,
    sources: {
        'esri-streets': {
            type: 'raster',
            tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}'],
            tileSize: 256,
            attribution: ESRI_ATTRIB,
            maxzoom: 19,
        },
    },
    layers: [
        { id: 'bg', type: 'background', paint: { 'background-color': '#e5e7eb' } },
        { id: 'streets', type: 'raster', source: 'esri-streets' },
    ],
};
export const TOPO_STYLE = {
    version: 8,
    glyphs: GLYPHS,
    sources: {
        'esri-topo': {
            type: 'raster',
            tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}'],
            tileSize: 256,
            attribution: ESRI_ATTRIB,
            maxzoom: 19,
        },
    },
    layers: [
        { id: 'bg', type: 'background', paint: { 'background-color': '#f3f4f6' } },
        { id: 'topo', type: 'raster', source: 'esri-topo' },
    ],
};
export const BASEMAPS = {
    satellite: { label: 'Satellite', style: SATELLITE_STYLE },
    streets: { label: 'Streets', style: STREETS_STYLE },
    topo: { label: 'Topo', style: TOPO_STYLE },
};
